import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import { toDropDownOptions } from 'utils/dropdownOptions';
import groupTypeOptions from 'constants/options/groupTypeOptions';
import microloanType from 'constants/options/microloanType';
import loanReason from 'constants/options/loanReason';
import FilterField from '../FilterField';

const MicroloanRequestsFilter = ({ form, handleChange }) => (
  <>
    <FilterField
      name="group_type"
      label="Group Type"
      placeholder="- All -"
      options={toDropDownOptions(groupTypeOptions)}
      value={form.group_type}
      onChange={handleChange}
    />
    <FilterField
      name="request_type"
      label="Microloan Type"
      placeholder="- All -"
      options={toDropDownOptions(microloanType)}
      value={form.request_type}
      onChange={handleChange}
    />
    <FilterField
      name="purpose"
      label="Loan reason"
      placeholder="- All -"
      options={toDropDownOptions(loanReason)}
      value={form.purpose}
      onChange={handleChange}
    />
    <Form.Input
      fluid
      type="date"
      label="Start Date"
      placeholder="Start Date"
      name="start_date"
      value={form.start_date || ''}
      onChange={handleChange}
    />
    <Form.Input
      fluid
      type="date"
      label="End Date"
      placeholder="End Date"
      name="end_date"
      value={form.end_date || ''}
      onChange={handleChange}
    />
  </>
);

MicroloanRequestsFilter.propTypes = {
  form: PropTypes.instanceOf(Object).isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default MicroloanRequestsFilter;
